var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFavoriteSolid = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9866 7.69364L12.714 1.19103C12.5778 0.92054 12.3017 0.75 12 0.75C11.6983 0.75 11.4222 0.92054 11.286 1.19103L8.01338 7.69364L0.686995 8.74392C0.383415 8.78744 0.131316 9.00144 0.0379804 9.29485C-0.0553548 9.58826 0.0265002 9.90945 0.248711 10.1217L5.53786 15.1743L4.29048 22.3074C4.23794 22.6079 4.3593 22.9123 4.60378 23.0933C4.84825 23.2743 5.17368 23.3006 5.44384 23.1613L12 19.7797L18.5562 23.1613C18.8263 23.3006 19.1517 23.2743 19.3962 23.0933C19.6407 22.9123 19.7621 22.6079 19.7095 22.3074L18.4621 15.1743L23.7513 10.1217C23.9735 9.90945 24.0554 9.58826 23.962 9.29485C23.8687 9.00144 23.6166 8.78744 23.313 8.74392L15.9866 7.69364Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFavoriteSolid);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/favorite-solid.60efcd3fa4bb68d6196aae7081e9e312.svg";